import React, { useEffect } from 'react';
import { useMatomo } from '@datapunt/matomo-tracker-react'
import { useNavigate } from 'react-router-dom';
import Header from '../../../Header/Header';
import Footer from '../../../Footer/Footer';
import { Typography, Grid, Box } from '@mui/material';
import numC1Image from '../../../assets/img/NUM_C1.png';

const TrayectoriaNUM_C1 = ({ }) => {

    const { trackPageView } = useMatomo();

    useEffect(() => {
        document.title = "Suma y Sigue | Trayectoria Formativa de Especialización para la Enseñanza de los Números y las Operaciones en Primer Ciclo Básico";
        trackPageView();
    }, []);

    const navigate = useNavigate();

    return (
        <Grid style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Header current={"trayectorias"} />
            <Grid
                p={"0 20px"}
                component="div"
                sx={{
                    flexGrow: 1,
                    m: '30px auto',
                    maxWidth: '940px',
                    width: '100%',
                }}
            >
                <Typography variant='subtitle' fontWeight={"bold"} m={"20px 0"} textAlign={"center"}>
                    Trayectoria Formativa de Especialización para la Enseñanza de los Números y las Operaciones en Primer Ciclo Básico
                </Typography>
                <Typography variant='p' mt={"40px"}>
                    Esta trayectoria formativa está dirigida especialmente a
                    profesores que imparten procesos de enseñanza aprendizaje
                    en el primer ciclo básico. Se enfoca en el desarrollo de
                    conocimientos especializados para enseñar contenidos
                    relacionados con la enseñanza de los números y operaciones
                    desde 1º a 4º básico.
                </Typography>
                <Typography variant='title-small' fontWeight={"bold"} mt={"20px"}>
                    Información general
                </Typography>
                <Typography variant='p' m={"20px 0"}>
                    <ul>
                        <li>
                            Dirigido a profesores/as de <b>1° a 4° básico</b>.
                        </li>
                        <li>
                            Enfocado en el eje de <b>Números y operaciones</b>.
                        </li>
                        <li>
                            Cursos Suma y Sigue:
                        </li>
                        <li style={{ listStyleType: 'none' }}>
                            <ul>
                                <li>Trabajando con el Sistema de Numeración Decimal</li>
                                <li>Trabajando con la Multiplicación y División</li>
                                <li>Trabajando con las Fracciones, los Decimales y sus Representaciones</li>
                                <li>Preparación de la Enseñanza y Evaluación de Aprendizajes de 1º ciclo</li>
                            </ul>
                        </li>
                        <li>
                            Modalidad de evaluación y aprobación:
                        </li>
                        <li style={{ listStyleType: 'none' }}>
                            <ul>
                                <li>La evaluación de cada curso contempla:</li>
                                <li style={{ listStyleType: 'none' }}>
                                    <ul>
                                        <li>Desarrollo de los talleres virtuales (30%)</li>
                                        <li>Controles (60%)</li>
                                        <li>Preguntas calificadas (10%)</li>
                                    </ul>
                                </li>
                                <li>
                                    Para aprobar la trayectoria se deben aprobar cada
                                    uno de los cursos que la componen.
                                </li>
                            </ul>
                        </li>
                    </ul>
                </Typography>
                <Typography variant='title-small' fontWeight={"bold"} mt={"40px"}>
                    Objetivos
                </Typography>
                <Typography variant='p' m={"20px 0"}>
                    <b>Objetivo general:</b> Desarrollar competencias
                    matemáticas y didácticas para conducir y evaluar la
                    enseñanza de los números y operaciones de 1° a 4°
                    básico.
                </Typography>
                <Typography variant='p' m={"20px 0"}>
                    <b>Objetivos específicos:</b>
                    <ul>
                        <li>
                            Fortalecer conocimientos disciplinares especializados
                            para la enseñanza de los números y operaciones,
                            atendiendo al desarrollo de habilidades matemáticas.
                        </li>
                        <li>Desarrollar competencias didácticas para preparar la
                            enseñanza de los números y operaciones centrada en el
                            aprendizaje de los estudiantes.
                        </li>
                        <li>Desarrollar competencias pedagógicas para evaluar el
                            aprendizaje de los estudiantes de los números y
                            operaciones, incorporando la evaluación de habilidades
                            matemáticas.
                        </li>
                    </ul>
                </Typography>
                <Typography variant='title-small' fontWeight={"bold"} mt={"40px"}>
                    Descripción de la trayectoria
                </Typography>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <Box
                        component="img"
                        sx={{
                            maxWidth: "100%",
                            maxHeight: "100%"
                        }}
                        alt="Suma y Sigue"
                        src={numC1Image}
                    />
                </Box>
                <Typography variant='p' fontWeight={"bold"} mt={"40px"}>
                    <span 
                        style={{ cursor: 'pointer', textDecoration: 'underline' }}
                        onClick={() => navigate('/trayectorias')}
                    >
                        ← Ver más trayectorias
                    </span>
                </Typography>
            </Grid>
            <Footer />
        </Grid>
    );

};

export default TrayectoriaNUM_C1;